import { render, staticRenderFns } from "./addTraining.vue?vue&type=template&id=4c5c8fe4&"
import script from "./addTraining.vue?vue&type=script&lang=js&"
export * from "./addTraining.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports